/*jslint browser: true */
/*global window:false, jQuery:false, ko:false */

;(function ($) {
    "use strict";

    var FirmAdLocation = function (model, options) {
        this.id = ko.observable(options.id);
        this.name = ko.observable(options.name);
        this.within = ko.observable(parseInt(options.within) >= 0 ? parseInt(options.within) : 0);
        this.type = ko.observable(options.type);
        this.model = model;
    };

    FirmAdLocation.prototype.withWithin = function () {
        return this.type == 'city';
    };

    FirmAdLocation.prototype.getData = function () {
        return {
            id: this.id(),
            within: this.within()
        };
    };

    FirmAdLocation.prototype.updateLoadedData = function (data) {
        this.name(data.short ? data.short : '');
        this.type(data.type ? data.type : '');
    };

    FirmAdLocation.prototype.delete = function () {
        model.deleteLocation(this);
    };

    window.ProfileFirmAdLocation = FirmAdLocation;
})(jQuery);